import { useMasterSubjectsSelector } from '../../../redux/selector';
import TreeMenu from '../../common/TreeMenu';
import usePermission from '../../../hooks/usePermission';

export default function PracticeManagement() {
  const subjects = useMasterSubjectsSelector();

  const dataTree = [
    {
      id: 'PRACTICE_IMPORT',
      title: 'Import đề',
      url: '/practice-management/import',
      children: [],
    },
    {
      id: 3,
      title: 'Ngân hàng đề tự luyện',
      children: subjects.map((subject) => ({
        id: subject.id,
        title: subject.name,
        url: `/practice-management/subject/${subject.id}/practices`,
      })),
    },
  ];

  usePermission(['ROLE_ADMIN', 'ROLE_COMPILER', 'ROLE_MASTER_COMPILER']);

  return <TreeMenu dataTree={dataTree} />;
}
